import React from "react";
import { UserProfile } from "auth/modules/state";
import { UserTotals } from "components/Analytics/Totals";
import { Data, MeasureGraphNew as Graph } from "./MeasureGraphNew";

import style from "./style.scss";

// this is the same as intervals
export interface OrgUserInterval {
    isoDate: string,
    interval: string,
    newUsers: number,
    returningUsers: number
}

export interface OrgUserTotals {
    returningUsers: number;
    newUsers: number;
    totalUsers: number;
    totalSessions: number;
}

export interface OrgAnalyticsUsersProps {
    organizationId: string;
    user?: UserProfile;
    totals?: OrgUserTotals;
    intervals?: OrgUserInterval[];
    /**
     * If true, only displays the totals and not the graph
     */
    readonly embedded?: boolean;
    /**
     * If the analytics are loading
     */
    readonly fetching?: boolean;
}

function convertData(orgId: string, analytics: OrgUserInterval[] = []): Data[] {
    if (analytics.length === 0) {
        return [];
    }

    const appData: Data[] = analytics.map((interval) => {
        return {
            orgId,
            date: new Date(interval.isoDate).toLocaleDateString(),
            newUsers: interval?.newUsers,
            returningUsers: interval?.returningUsers,
            total: interval?.newUsers + interval?.returningUsers,
        };
    });

    return appData;
}

export const OrgAnalyticsUsers: React.FC<OrgAnalyticsUsersProps> = (props) => {

    const { organizationId, intervals, totals, embedded, fetching } = props;

    return (
        <>
            {embedded ? (
                <UserTotals {...totals} fetching={fetching} />
            ) : (
                <div>
                    <UserTotals {...totals} fetching={fetching} />
                    <div className={style.graphWrap}>
                        <h2 className={style.graphTitle}>New &amp; Returning Users Per Day</h2>
                        <Graph height={500} data={convertData(organizationId, intervals)} fetching={fetching} />
                    </div>
                </div>
            )}
        </>
    );
};